var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetActivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8695",
    "data-name": "Rectangle 8695",
    width: 16.958,
    height: 16.956,
    fill: "#0072ce"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Fleet_Activity"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fleet_Activity",
    "data-name": "Fleet Activity",
    clipPath: "url(#clip-Fleet_Activity)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11770",
    "data-name": "Group 11770",
    transform: "translate(0.521 0.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11769",
    "data-name": "Group 11769",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22212",
    "data-name": "Path 22212",
    d: "M328.548,2.434c-.086.206-.126.428-.233.628a2.1,2.1,0,1,1-2.379-3c.059-.016.134,0,.179-.063h.667c.047.058.12.047.181.062a2.078,2.078,0,0,1,1.3.967,3.6,3.6,0,0,1,.285.737Zm-2.918-.346a.82.82,0,0,0,.821.838.843.843,0,0,0,.842-.828.852.852,0,0,0-.83-.841.832.832,0,0,0-.832.831",
    transform: "translate(-311.59)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22213",
    "data-name": "Path 22213",
    d: "M8.156,32.106c-1.014,0-2.028.021-3.041-.038a6.417,6.417,0,0,1-2.456-.49A4.25,4.25,0,0,1,.237,28.536a12.385,12.385,0,0,1-.226-2.55q-.023-2.031,0-4.062a11.356,11.356,0,0,1,.27-2.757,4.235,4.235,0,0,1,2.377-2.851A4.8,4.8,0,0,1,4.274,15.9c2.14-.217,4.286-.082,6.429-.116a.626.626,0,0,1,0,1.251c-1.478.007-2.957,0-4.435.019a12.793,12.793,0,0,0-2.473.211,3.05,3.05,0,0,0-2.3,2.282,16.044,16.044,0,0,0-.228,3.118c-.022,1.387-.018,2.774.039,4.16a6.3,6.3,0,0,0,.269,1.786,2.923,2.923,0,0,0,2.192,2,11.957,11.957,0,0,0,2.687.228c1.524.023,3.048.032,4.571-.033a6.335,6.335,0,0,0,1.81-.27,2.916,2.916,0,0,0,2.007-2.211,15.027,15.027,0,0,0,.233-3.255c.015-1.2,0-2.394,0-3.591a.629.629,0,1,1,1.254-.01c0,1.5.015,3-.006,4.494a9.719,9.719,0,0,1-.348,3,4.184,4.184,0,0,1-3.208,2.9,12.181,12.181,0,0,1-2.491.23c-.706.016-1.413,0-2.119,0",
    transform: "translate(0 -15.155)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22214",
    "data-name": "Path 22214",
    d: "M91.292,151.184a2.265,2.265,0,0,1-2.064-1.4.99.99,0,0,0-1.345-.54,1.048,1.048,0,0,0-.513.542q-.584,1.2-1.173,2.388a.633.633,0,0,1-.67.373.646.646,0,0,1-.533-.531.6.6,0,0,1,.072-.4c.407-.832.8-1.67,1.226-2.493a2.253,2.253,0,0,1,4.074.111.994.994,0,0,0,.927.664.984.984,0,0,0,.949-.632c.387-.805.78-1.608,1.186-2.4a.62.62,0,0,1,1.089-.076.585.585,0,0,1,.049.612c-.43.872-.84,1.754-1.294,2.613a2.193,2.193,0,0,1-1.98,1.167",
    transform: "translate(-81.64 -140.739)",
    fill: "#0072ce"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetActivity);
export default __webpack_public_path__ + "static/media/Fleet Activity.56961fd81bc4aee7b4731b03bfae4ef9.svg";
export { ForwardRef as ReactComponent };